import React from 'react';
import Header from './Header';
import Sidebar from './sideBar';
import { useProfileGuard } from '../hooks/useProfileGuard';

const Layout = ({ children }) => {
  const { profile, loading, error, bootedOut } = useProfileGuard();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-gray-600">Loading…</div>
      </div>
    );
  }

  if (bootedOut || error || !profile) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="bg-white border border-red-200 rounded-2xl shadow-lg max-w-md w-full p-8 text-center">
          <h2 className="text-xl font-bold text-gray-900 mb-2">Signed out</h2>
          <p className="text-gray-600 text-sm mb-6">
            {error || 'Your profile could not be loaded. Please sign in again.'}
          </p>
          <a
            href="/login"
            className="inline-block px-6 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700"
          >
            Go to login
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar />
      <div className="ml-64">
        <Header />
        <main className="p-6">{children}</main>
      </div>
    </div>
  );
};

export default Layout;